/* eslint-disable react/forbid-component-props */
import { CarouselProvider } from '@/components/blocks/Carousel/CarouselProvider';
import { CarouselSlide } from '@/components/blocks/Carousel/CarouselSlide';
import { carouselCustomProviderSX } from '@/components/blocks/CarouselAds/styles/CarouselProviderSX';
import { Grid } from '@mui/material';
import { DotGroup, Slider } from 'pure-react-carousel';
import React, { FC, useMemo } from 'react';

type Props = {
	slides?: JSX.Element[];
	children?: JSX.Element[];
	id?: string;
	withoutmargin?: boolean;
	carouselProps?: any;
	a11yProps?: any;
	carouselSlideStyles?: any;
};

const defaultCarouselProps = {
	naturalSlideWidth: 248,
	naturalSlideHeight: 300,
	visibleSlides: 1,
	step: 1,
	infinite: true,
	dragEnabled: false,
	totalSlides: 1,
	isIntrinsicHeight: true,
};

export const CarouselSlider: FC<Props> = ({ id, slides, withoutmargin = false, children }) => {
	const _slides = useMemo(() => {
		if (slides) return slides;
		const cleanChildren = React.Children.toArray(children).filter((child) =>
			React.isValidElement(child)
		);
		return cleanChildren;
	}, [slides, children]);

	const sxProv = carouselCustomProviderSX(_slides.length, withoutmargin);

	return (
		<CarouselProvider
			isPlaying
			interval={8000}
			{...defaultCarouselProps}
			totalSlides={_slides.length}
			sx={sxProv}
			{...{ id }}
		>
			<Slider style={{ overflow: 'hidden' }}>
				{_slides.map((slide, index) => (
					<CarouselSlide index={index} key={`id_carousel_${index}`}>
						{slide}
					</CarouselSlide>
				))}
			</Slider>
			{_slides.length > 1 ? (
				<Grid
					width={'100%'}
					position={'absolute'}
					justifyContent={'center'}
					display={'inline-flex'}
					bottom={'16px'}
					zIndex={'20'}
				>
					<DotGroup />
				</Grid>
			) : null}
		</CarouselProvider>
	);
};
